import { getGradeRTotalPresetWorksheetCount } from "./gradeRPresetWorksheetCatalog";

export { getGradeRTotalPresetWorksheetCount };

export const GRADE_LABELS: Record<string, string> = {
  "grade-r": "Grade R",
  "grade-1": "Grade 1",
  "grade-2": "Grade 2",
};

export const WORKSHEET_ACTIVITY_LABELS: Record<string, string> = {
  coloring: "Coloring",
  counting: "Counting",
  matching: "Matching",
  tracing: "Words",
  poems: "Poems",
  abc: "Alphabet (ABC)",
  math: "Math",
  literacy: "Literacy",
  "life-skills": "Life-Skills",
  "robotics-and-coding": "Robotics-and-Coding",
};

export const GRADE_1_ACTIVITY_PRESET_COUNTS = {
  math: 36,
  literacy: 10,
  "life-skills": 0,
  "robotics-and-coding": 20,
} as const;

export const GRADE_2_ACTIVITY_PRESET_COUNTS = {
  math: 20,
  literacy: 20,
  "life-skills": 20,
} as const;

export function getGradeLabel(gradeKey: string): string {
  return GRADE_LABELS[gradeKey] || GRADE_LABELS["grade-r"];
}

export function getGrade1TotalPresetWorksheetCount(): number {
  return Object.values(GRADE_1_ACTIVITY_PRESET_COUNTS).reduce<number>(
    (sum, value) => sum + value,
    0,
  );
}

export function getGrade2TotalPresetWorksheetCount(): number {
  return Object.values(GRADE_2_ACTIVITY_PRESET_COUNTS).reduce<number>(
    (sum, value) => sum + value,
    0,
  );
}

export function getGradePresetWorksheetCount(gradeKey: string): number {
  if (gradeKey === "grade-1") return getGrade1TotalPresetWorksheetCount();
  if (gradeKey === "grade-2") return getGrade2TotalPresetWorksheetCount();
  if (gradeKey === "grade-r") return getGradeRTotalPresetWorksheetCount();
  return 0;
}

/** Shown in place of Grade 2's worksheets while they're rebuilt. */
export const GRADE_2_REBUILDING_TEXT =
  "Grade 2 worksheets are being rebuilt. Grade R and Grade 1 are available now.";

/**
 * The kinds of worksheet each open grade offers, in the order its page lists
 * them. WorksheetsGrade hides or greys out the rest (Grade R Matching, Grade 1
 * Life-Skills). Grade 2 has none while it's rebuilt.
 */
export const WORKSHEET_GRADE_ACTIVITIES: Record<string, string[]> = {
  "grade-r": ["coloring", "abc", "tracing", "poems", "counting"],
  "grade-1": ["math", "literacy", "robotics-and-coding"],
};

/** The ready-made worksheets Library counts: Grade R's and Grade 1's. */
export function getLibraryWorksheetTotal(): number {
  return getGradeRTotalPresetWorksheetCount() + getGrade1TotalPresetWorksheetCount();
}
